import { render, staticRenderFns } from "./price_changing.vue?vue&type=template&id=4504cc66&"
import script from "./price_changing.vue?vue&type=script&lang=js&"
export * from "./price_changing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports